import React, { useMemo } from 'react';
import { SingleValue } from 'react-select';
import { CreatableReactSelectMenu } from '../../../Dropdown/StyledReactSelect';
import { BasicSingleValue } from '../../../Dropdown/StyledReactSelect/SelectUtils';
import { ICreatableReactSelectOption } from '../../../../utils/types';
import { MAX_MEASURE_ROLLING_CONTROL_VALUE } from '../../../../config/constants';

interface IProps {
  value: string | null;
  onChange: (window: number) => void;
  autoFocus?: boolean;
}

const defaultOptions: ICreatableReactSelectOption[] = [
  {
    value: '7',
    label: '7',
  },
  {
    value: '30',
    label: '30',
  },
];

export default ({ value, onChange, autoFocus }: IProps) => {
  const handleChange = (option: SingleValue<ICreatableReactSelectOption>) => {
    onChange(option?.value ? Number(option.value) : 0);
  };

  const handleValidateNewOption = (inputValue: string) => {
    // Only numbers acceptable
    if (
      !inputValue?.length ||
      Number.isNaN(+inputValue) ||
      inputValue.length > 2
    ) {
      return false;
    }

    const numericValue = +inputValue;

    // Rolling inputs are limited from 1 to 90
    if (numericValue < 1 || numericValue > MAX_MEASURE_ROLLING_CONTROL_VALUE) {
      return false;
    }

    return !defaultOptions.some(
      (defaultOption) => defaultOption.value === inputValue,
    );
  };

  const handleCreateValue = (inputValue: string) => {
    // A new option is already valid, so we can call onChange without a doubt
    onChange(Number(inputValue));
  };

  const selectedOption: ICreatableReactSelectOption | null = useMemo(() => {
    if (!value) {
      return null;
    }

    return (
      (defaultOptions.find((option) => option.value === value) ?? {
        value,
        label: value,
      }) ||
      null
    );
  }, [value]);

  return (
    <CreatableReactSelectMenu
      value={selectedOption}
      onChange={handleChange}
      isValidNewOption={handleValidateNewOption}
      onCreateOption={handleCreateValue}
      isMulti={false}
      options={defaultOptions}
      components={{
        SingleValue: BasicSingleValue,
      }}
      styles={{
        control: (base) => ({
          ...base,
          flex: '0 0 auto',
          minWidth: '70px',
          width: '70px',
        }),
      }}
      autoFocus={autoFocus}
      openMenuOnFocus={autoFocus}
      closeMenuOnSelect
      blurInputOnSelect
    />
  );
};
